(() => {
  const apiBase = 'https://informationcollection.benyuan1.com/api/trendFavorite'

  const unwrap = (result) => result?.data && typeof result.data === 'object' && 'success' in result.data ? result.data : result
  const succeeded = (result) => {
    const data = unwrap(result)
    return data?.success === true || result?.status === 'success'
  }
  const postRequest = async (path, body) => {
    const response = await fetch(`${apiBase}/${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    if (!response.ok) throw new Error('Unable to load journey data')
    const result = await response.json()
    if (!succeeded(result)) throw new Error('Journey data request was not successful')
    return unwrap(result)?.data || []
  }
  const request = (body) => postRequest('list', body)
  const emptyState = (panel, message) => {
    panel.innerHTML = `<p class="nail-journeys__empty">${message}</p>`
  }
  const loadingState = (panel) => {
    panel.innerHTML = Array.from({ length: 4 }, () => `
      <div class="nail-journeys__skeleton" aria-hidden="true">
        <span class="nail-journeys__skeleton-media"></span>
        <span class="nail-journeys__skeleton-line nail-journeys__skeleton-line--title"></span>
        <span class="nail-journeys__skeleton-line"></span>
        <span class="nail-journeys__skeleton-line nail-journeys__skeleton-line--short"></span>
      </div>
    `).join('')
  }
  const preloadCardImages = (root, type) => {
    const source = root.querySelector(type === 'academy' ? '[data-nail-journeys-academy-source]' : '[data-nail-journeys-trend-source]')
      || (type === 'trend' ? root.querySelector('[data-nail-journeys-source]') : null)
    if (!source || source.dataset.imagesPreloaded === 'true') return
    source.dataset.imagesPreloaded = 'true'
    source.querySelectorAll('img[src]').forEach((image) => {
      const preload = new Image()
      preload.src = image.currentSrc || image.src
    })
  }
  const renderCards = (root, panel, ids, type = 'trend', progressState) => {
    panel.innerHTML = ''
    const source = root.querySelector(type === 'academy' ? '[data-nail-journeys-academy-source]' : '[data-nail-journeys-trend-source]')
      // Keep existing published section markup working while the section update propagates.
      || (type === 'trend' ? root.querySelector('[data-nail-journeys-source]') : null)
    const selector = type === 'academy' ? '.nail-academy__tutorial-card' : '.seasonal-trends__card'
    const cards = source ? [...source.querySelectorAll(selector)] : []
    const idSet = new Set(ids.map(String))
    cards.filter((card) => idSet.has(type === 'academy' ? card.dataset.trendId : card.querySelector('[data-seasonal-trends-save]')?.dataset.trendId)).forEach((card) => {
      const copy = card.cloneNode(true)
      if (type === 'academy') {
        const progress = copy.querySelector('[data-academy-progress]')
        if (progress) {
          progress.dataset.progressState = progressState
          progress.setAttribute('aria-label', progressState === 'complete' ? 'Tutorial completed' : 'Tutorial saved to your learning list')
          const usesRemoveControl = root.dataset.nailJourneysPage === 'true' || root.classList.contains('my-profile__journeys')
          const removeIconUrl = root.dataset.nailJourneysRemoveIcon
          if (usesRemoveControl && removeIconUrl) {
            const icon = document.createElement('img')
            icon.src = removeIconUrl
            icon.alt = ''
            icon.width = 32
            icon.height = 32
            progress.replaceChildren(icon)
            progress.classList.add('nail-journeys__remove-button')
            const listName = progressState === 'complete' ? 'completed list' : 'to-learn list'
            progress.setAttribute('aria-label', `Remove ${copy.dataset.trendTitle || 'tutorial'} from ${listName}`)
          }
        }
      } else {
        const save = copy.querySelector('[data-seasonal-trends-save]')
        if (save) save.setAttribute('aria-pressed', 'true')
      }
      panel.appendChild(copy)
    })
    return panel.children.length
  }
  const paginate = (panel) => {
    const cards = [...panel.querySelectorAll('.seasonal-trends__card, .nail-academy__tutorial-card')]
    const pageSize = () => 8
    const existing = panel.parentElement.querySelector(`[data-nail-journeys-pagination="${panel.dataset.nailJourneysPanel}"]`)
    existing?.remove()
    if (cards.length <= pageSize()) return
    let page = 0
    const pageCount = () => Math.ceil(cards.length / pageSize())
    const pagination = document.createElement('nav')
    pagination.className = 'nail-journeys__pagination'
    pagination.dataset.nailJourneysPagination = panel.dataset.nailJourneysPanel
    pagination.setAttribute('aria-label', 'Card pagination')
    const update = () => {
      const size = pageSize()
      page = Math.min(page, pageCount() - 1)
      cards.forEach((card, index) => { card.hidden = index < page * size || index >= (page + 1) * size })
      pagination.innerHTML = `<button type="button" data-page="first" aria-label="First page">‹‹</button><button type="button" data-page="previous" aria-label="Previous page">‹</button>${Array.from({ length: pageCount() }, (_, index) => `<button type="button" data-page="${index}" ${index === page ? 'aria-current="page"' : ''}>${index + 1}</button>`).join('')}<button type="button" data-page="next" aria-label="Next page">›</button><button type="button" data-page="last" aria-label="Last page">››</button>`
    }
    pagination.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-page]')
      if (!button) return
      const target = button.dataset.page
      if (target === 'first') page = 0
      else if (target === 'previous') page -= 1
      else if (target === 'next') page += 1
      else if (target === 'last') page = pageCount() - 1
      else page = Number(target)
      update()
    })
    panel.insertAdjacentElement('afterend', pagination)
    update()
  }
  const setActiveTab = (root, name) => {
    root.querySelectorAll('[data-nail-journeys-tab]').forEach((tab) => {
      const active = tab.dataset.nailJourneysTab === name
      tab.classList.toggle('is-active', active)
      tab.setAttribute('aria-selected', String(active))
    })
    root.querySelectorAll('[data-nail-journeys-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.nailJourneysPanel !== name
    })
  }
  const clearPagination = (panel) => {
    panel.parentElement.querySelector(`[data-nail-journeys-pagination="${panel.dataset.nailJourneysPanel}"]`)?.remove()
  }
  const loadTab = async (root, name) => {
    const panel = root.querySelector(`[data-nail-journeys-panel="${name}"]`)
    if (!panel) return
    const requestId = String(Number(panel.dataset.requestId || 0) + 1)
    panel.dataset.requestId = requestId
    clearPagination(panel)
    panel.setAttribute('aria-busy', 'true')
    preloadCardImages(root, name === 'favorites' ? 'trend' : 'academy')
    loadingState(panel)
    try {
      if (name === 'favorites') {
        const favorites = await request({ user_id: root.dataset.customerId, category: 'all', type: 1 })
        if (panel.dataset.requestId !== requestId) return
        const favoriteIds = favorites.map((item) => item.trend_id)
        if (!renderCards(root, panel, favoriteIds)) emptyState(panel, 'No loved designs yet.')
      } else {
        const learning = await request({ user_id: root.dataset.customerId, category: 'all', type: 2 })
        if (panel.dataset.requestId !== requestId) return
        const ids = learning
          .filter((item) => name === 'completed' ? Number(item.learn_status) === 1 : Number(item.learn_status) !== 1)
          .map((item) => item.trend_id)
        const state = name === 'completed' ? 'complete' : 'pending'
        const message = name === 'completed'
          ? 'Complete a tutorial to celebrate it here.'
          : 'Your to-learn list is ready for its first tutorial.'
        if (!renderCards(root, panel, ids, 'academy', state)) emptyState(panel, message)
      }
      window.TrendFavoriteCounts?.refresh(panel)
      paginate(panel)
    } catch {
      if (panel.dataset.requestId === requestId) {
        const message = name === 'favorites'
          ? 'We could not load your loved designs right now. Please try again.'
          : 'We could not load this learning list right now. Please try again.'
        emptyState(panel, message)
      }
    } finally {
      if (panel.dataset.requestId === requestId) panel.setAttribute('aria-busy', 'false')
    }
  }
  const initialise = (root) => {
    if (root.dataset.ready === 'true') return
    root.dataset.ready = 'true'
    if (root.dataset.nailJourneysPage === 'true') document.documentElement.classList.add('nail-journeys-page')
    root.querySelectorAll('[data-nail-journeys-tab]').forEach((tab) => tab.addEventListener('click', () => {
      if (root.dataset.customerLoggedIn !== 'true' || !root.dataset.customerId) {
        root.__likeShareAuth?.setTab?.('login')
        root.__likeShareAuth?.openModal?.()
        return
      }
      const name = tab.dataset.nailJourneysTab
      setActiveTab(root, name)
      loadTab(root, name)
    }))

    if (root.dataset.customerLoggedIn !== 'true' || !root.dataset.customerId) {
      return
    }

    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-seasonal-trends-save]')
      if (!button || button.closest('[data-nail-journeys-panel]')?.dataset.nailJourneysPanel !== 'favorites') return
      event.preventDefault()
      event.stopPropagation()
      if (button.getAttribute('aria-pressed') !== 'true' || button.disabled) return
      button.disabled = true
      button.setAttribute('aria-busy', 'true')
      try {
        await postRequest('unfavorite', {
          user_id: root.dataset.customerId,
          user_name: root.dataset.customerName,
          email: root.dataset.customerEmail,
          trend_id: button.dataset.trendId,
          type: 1
        })
        loadTab(root, 'favorites')
      } catch {
        button.disabled = false
        button.setAttribute('aria-busy', 'false')
      }
    })
    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-academy-progress]')
      const panelName = button?.closest('[data-nail-journeys-panel]')?.dataset.nailJourneysPanel
      if (!button || !['learning', 'completed'].includes(panelName)) return
      event.preventDefault()
      event.stopPropagation()
      if (button.disabled) return
      const trendId = button.closest('[data-academy-card]')?.dataset.trendId
      if (!trendId) return
      button.disabled = true
      button.setAttribute('aria-busy', 'true')
      try {
        await postRequest('unfavorite', {
          user_id: root.dataset.customerId,
          user_name: root.dataset.customerName,
          email: root.dataset.customerEmail,
          trend_id: trendId,
          type: 2
        })
        loadTab(root, panelName)
      } catch {
        button.disabled = false
        button.setAttribute('aria-busy', 'false')
      }
    })
    const requestedTab = new URLSearchParams(window.location.search).get('tab')
    const initialTab = ['favorites', 'learning', 'completed'].includes(requestedTab) ? requestedTab : 'favorites'
    setActiveTab(root, initialTab)
    preloadCardImages(root, initialTab === 'favorites' ? 'trend' : 'academy')
    loadTab(root, initialTab)
  }
  const mount = (scope = document) => scope.querySelectorAll('[data-nail-journeys]').forEach(initialise)
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => mount()) : mount()
  document.addEventListener('shopify:section:load', (event) => mount(event.target))
})()
